(function () {
    'use strict';

    var mote = {
        template: '<span ng-if="!$ctrl.mote">[{{"divisa.sinvalor" | translate}}]</span>' +
            '<span ng-if="$ctrl.mote">{{$ctrl.mote}}</span>'+
            '<span ng-if="$ctrl.detalle"> ({{$ctrl.detalle}})</span>',
        bindings: {
            mote: '@',
            detalle: '@'
        }
    };

    angular
        .module('app')
        .component('mote', mote);

})();
